import { Card, Typography } from '@mui/material';
import React from 'react';

import CrashIndicator from '../../../../images/csa/crash.svg';
import ControlledSubstancesAlcohol from '../../../../images/csa/cs.svg';
import DriverFitness from '../../../../images/csa/df.svg';
import HazardousMaterials from '../../../../images/csa/hm.svg';
import HosCompliance from '../../../../images/csa/hos.svg';
import UnsafeDriving from '../../../../images/csa/ud.svg';
import VehicleMaintenance from '../../../../images/csa/vm.svg';
import palette from '../../../ColorPalette';

export const TITLE_MAP = {
    unsafe_driving_score: 'Unsafe Driving',
    crash_indicator_score: 'Crash Indicator',
    hos_compliance_score: 'HOS Compliance',
    vehicle_maintenance_score: 'Vehicle Maintenance',
    controlled_substances_alcohol_score: 'Controlled Substances and Alcohol',
    hazardous_materials_score: 'Hazardous Materials',
    driver_fitness_score: 'Driver Fitness',
    iss_score: 'ISS Score',
};

const IMAGE_MAP = {
    unsafe_driving_score: UnsafeDriving,
    crash_indicator_score: CrashIndicator,
    hos_compliance_score: HosCompliance,
    vehicle_maintenance_score: VehicleMaintenance,
    controlled_substances_alcohol_score: ControlledSubstancesAlcohol,
    hazardous_materials_score: HazardousMaterials,
    driver_fitness_score: DriverFitness,
};

interface CsaScoreCardProps {
    type: string;
    value: number;
    isSelected: boolean;
    onSelectScore: CallableFunction;
}

const CsaScoreCard: React.FC<CsaScoreCardProps> = (props: CsaScoreCardProps) => {
    const title = TITLE_MAP[props.type as keyof typeof TITLE_MAP];

    return (
        <Card
            id={`${props.type.replaceAll('_', '-')}-card`}
            data-testid={`${props.type.replaceAll('_', '-')}-card`}
            onClick={() => props.onSelectScore()}
            sx={{
                height: '175px',
                flex: 1,
                minWidth: '120px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: 2,
                px: 1,
                backgroundColor: props.isSelected ? palette.white : palette.neutral[200],
                '&:hover': {
                    backgroundColor: props.isSelected ? palette.white : palette.neutral[150],
                },
                transition: 'background-color 0.2s',
                userSelect: 'none',
                cursor: 'pointer',
            }}
        >
            <img src={IMAGE_MAP[props.type as keyof typeof IMAGE_MAP]} alt={title} />
            <Typography variant="overline" textAlign="center" sx={{ lineHeight: 1.5 }}>
                {title}
            </Typography>
            <Typography
                data-testid={`${props.type.replaceAll('_', '-')}-value`}
                data-value={props.value}
                sx={{ fontSize: 24, fontWeight: 'bold', lineHeight: 1, color: palette.primary }}
            >
                {props.value}
            </Typography>
        </Card>
    );
};

export default CsaScoreCard;
